import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const TooltipContainer = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.18 }}
      css={containerStyle}
      className={className}
    >
      {typeof children === 'string' ? (
        <Text size='medium' color='white'>
          {children}
        </Text>
      ) : (
        children
      )}
    </motion.div>
  );
};

const containerStyle = css({
  pointerEvents: 'none',
  userSelect: 'none',
  borderRadius: theme.borderRadius.medium,
  background: theme.colors.black,
  boxShadow: theme.shadows.light,
  padding: theme.spacing(1),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: 'max-content',
});
